import React from 'react';
import ApolloClient from 'apollo-boost';
import { ApolloProvider } from '@apollo/react-hooks';
import Layout from '../../components/layout';
import SEO from '../../components/seo';
import { SettingProvider } from '../../lib/context/settings';
import { AdsProvider } from '../../lib/context/ads';
import { Button, Col, Row } from 'antd';
import { SectionTitle, Title } from '../../components/styles';
import styled from 'styled-components';
import { device } from '../../lib/theme';

const client = new ApolloClient<any>({
  uri: `https://${process.env.GATSBY_WORDPRESS_URL_PATH}/graphql`,
  fetchOptions: {
    credentials: 'include',
  },
});

const HeroContainer = styled(Row)`
  background-image: url('https://aaacdndev.blob.core.windows.net/wordpress/2021/01/20-PD-0326-C-AEM-1200x400-bnr.png');
  background-size: cover;
  background-position: right;
  background-repeat: no-repeat;
  height: 340px;

  h1 {
    max-width: 80%;
    font-size: 32px;
    line-height: 1.1;
  }

  @media ${device.laptop} {
    h1 {
      max-width: 60%;
      font-size: 56px;
      line-height: 1.2;
    }

    background-position: center center;
  }
`;

const ChromeExtentionPostVal: React.FC<any> = () => {
  return (
    <ApolloProvider client={client as any}>
      <SettingProvider>
        <AdsProvider>
          <Layout key={`${typeof window}`}>
            <SEO
              title="Award Winning Insurance"
              description=""
              image="https://aaacdndev.blob.core.windows.net/wordpress/homepage/ins_banner_small.jpg"
              canonicalUrl="/insurance/awards"
            />

            <Row style={{ paddingTop: 48, marginBottom: 64 }}>
              <Col xs={{ span: 22, offset: 1 }} md={{ span: 20, offset: 2 }}>
                <Title style={{ textAlign: 'center' }}>
                  Award Winning Insurance
                </Title>
                <h3>
                  AAA Carolinas Insurance named 2018 Multi-Line Insurance Brand
                  of the Year by the Independent and Prestigious 2018 Harris
                  Poll Equitrend Study.
                </h3>
                <div
                  style={{ margin: 'auto', width: '100%', textAlign: 'center' }}
                >
                  <img
                    src="https://aaacdndev.blob.core.windows.net/wordpress/homepage/ins_banner_small.jpg"
                    style={{ maxWidth: '100%', marginTop: 16, maxHeight: 300 }}
                    alt="#1 Again image"
                  />
                </div>

                <p>
                  At AAA Insurance, we are more than just consultants, we are
                  trusted advisors. In addition to offering Member discounts and
                  additional coverages, we provide what really matters, total
                  peace of mind. No matter where you are in life, AAA has an
                  insurance policy just for you.
                </p>
                <Button
                  style={{ marginTop: 16 }}
                  type="primary"
                  href="https://www.aaacarolinasinsurancesolutions.com/quote/html/"
                >
                  Get A Quote
                </Button>
                <p style={{ marginTop: 8 }}>
                  Or Call <a href="tel:18663151252">1-866-315-1252</a>
                </p>
                <div
                  style={{
                    backgroundColor: '#E4F2FE',
                    padding: 32,
                    marginTop: 16,
                    width: '90%',
                  }}
                >
                  <h2>
                    <strong>
                      <i>
                        {' '}
                        “It is such an honor to receive the Harris Poll award on
                        behalf of our team and it speaks volumes about our
                        commitment to our members that the award is solely based
                        upon customer reviews.”
                        <br />
                        <br />– Jim McCafferty, President of AAA Carolinas
                        Insurance
                      </i>
                    </strong>
                  </h2>
                </div>
                <p style={{ marginTop: 32 }}>
                  The Harris Poll researches and then awards the strongest
                  brands across the media, travel, financial, automotive,
                  entertainment, retail, restaurant, technology, household and
                  nonprofit industries based on consumer response to multiple
                  studies.
                </p>
                <strong>
                  <p>
                    Measuring brand health over time, the EquiTrend Brand Equity
                    Index is comprised of three factors:
                  </p>
                  <ul>
                    <li>Familiarity</li>
                    <li>Quality</li>
                    <li>Purchase Consideration</li>
                  </ul>
                </strong>
                <p>
                  Brands ranking highest in equity receive the Harris Poll
                  EquiTrend “Brand of the Year” award for their respective
                  categories. This year, more than 77,000 U.S. consumers
                  assessed more than 3,000 brands across more than 300
                  categories.
                </p>
                <p>
                  <strong>
                    Give our agents a call. They’ll show you how AAA Insurance
                    can protect you, your family and your assets. We’re here for
                    your peace of mind.
                  </strong>
                </p>
                <Button
                  style={{ marginTop: 16 }}
                  type="primary"
                  href="https://www.aaacarolinasinsurancesolutions.com/quote/html/"
                >
                  Get A Quote
                </Button>
                <p style={{ marginTop: 8 }}>
                  Or Call <a href="tel:18663151252">1-866-315-1252</a>
                </p>
              </Col>
            </Row>
          </Layout>
        </AdsProvider>
      </SettingProvider>
    </ApolloProvider>
  );
};

export default ChromeExtentionPostVal;
